<template>
  <div class="upload-img">
    <div class="content-wrapper">
      <div class="upload-img-content">
        <p class="content-title">{{formItem.title}}</p>
        <p class="content-subtitle">{{formItem.sub_title}}</p>
        <p class="content-p" v-for="(t,idx) in sample" :key="idx" v-html="t"></p>
      </div>
    </div>
    <div class="upload-input-wrapper" v-if="(formItem.value!=1 || formItem.field_status == 5) && formItem.desc_title">
      <p class="declare" @click="declareClick" v-if="formItem.desc_title">
        <i :class="[{active:aggre}, {'declare-br-checked': country === 'BR'}]"></i>
        {{formItem.desc_title}}
        <span
          class="rule"
          @click="go()"
        >{{formItem.desc_title_link.title}}</span>
      </p>
      <div
        :class="{'multi-upload-input':1,'multi-upload-input-active':aggre}"
        @click="submitImg"
      >{{$t('img.submit_btn_txt')}}</div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { post } from "../../tools/request";
import { showLoadingToast, showAlertDialog } from "../../tools/Tip";

export default {
  name: "declare",
  data() {
    return {
      aggre: false
    };
  },
  computed: {
    ...mapState(["_ticket"]),
    country() {
      let up = new URLSearchParams(location.search)
      return up.get('location_country')
    },
    //传递过来整个对象
    formItem() {
      let c = this.$route.params.configs;
      return c || {};
    },
    sample() {
      return this.formItem.content || [];
    }
  },

  beforeCreate() {
    //一旦进入上传页，返回按钮就正常返回
    Fusion.resetBack &&
      Fusion.resetBack({
        reset: 2
      });
  },
  mounted() {
    // @20210824 whatsapp授权页面埋点
    // if (this.formItem.key === 'whatsapp_auth_declare') {
    //   try {
    //     Omega.trackEvent("driver_lic_upload_whatsapp_support_sw");
    //   } catch (e) {}
    // }
    
    this.aggre = this.formItem.is_checked || false;
  },
  methods: {
    declareClick() {
      this.aggre = !this.aggre;
      this.$emit("btn-update");
    },
    go() {
      location.href = this.formItem.desc_title_link.url;
    },
    submitImg() {
      if (!this.aggre) {
        return;
      }

      showLoadingToast(this);
      let up = new URLSearchParams(location.search);

      if (this.formItem.auth_api) {
        let config = {
          ticket: this._ticket || up.get('ticket') || '',
          appId: 100001,
          auth: 1
        }
        // @20210824 whatsapp点击授权埋点
        // if (this.formItem.key === 'whatsapp_auth_declare') {
        //   try {
        //     Omega.trackEvent("driver_lic_upload_whatsapp_confirm_ck");
        //   } catch (e) {}
        // }
        post(this.formItem.auth_api, new URLSearchParams(config))
        .then((res) => console.log(res))
        .catch((err) => console.log(err));
      }
      
      up.append(this.formItem.key, 1);
      //兼容各个国家情况，vuex中如果存在ticket，则优先信任
      if (this._ticket) {
        up.set("ticket", this._ticket);
      }
      // @20190213 支持任务中心,type|uid
      if (this.formItem.job_type) {
        up.append("job_type", this.formItem.job_type);
      }
      if (this.formItem.job_uid) {
        up.append("job_uid", this.formItem.job_uid);
      }
      const otherUp = this.formItem.otherUp;
      if (otherUp) {
        otherUp.url && (_url = otherUp.url);
        if (otherUp.up) {
          Object.keys(otherUp.up).forEach(item => {
            up.append(item, otherUp.up[item]);
          })
        }
      }
      let success = data => {
        this.toast.hide();
        if (otherUp && otherUp.callback) {
          otherUp.callback(data);
        } else {
          this.$router.replace({ name: "home" });
        }
      };
      post(process.env.ADD_AUDI_INFO, up)
        .then(success)
        .catch(err => {
          this.httpError();
          try {
            Omega.trackEvent("ibt_register_submit_review_error_ck", '', {
              path_url: process.env.ADD_AUDI_INFO,  //接口url
              message: JSON.stringify(err),  //全部返回信息
              request: up.toString(),  //请求参数信息
              errno: err.errno,  //报错码
            });
          } catch (e) {}
        });
    },
    httpError() {
      this.toast.hide();
      showAlertDialog(this, this.$t("ERROR_DEFAULT_TEXT"));
    }
  }
};
</script>

<style lang="scss" scoped>
.upload-img {
  min-height: 100%;
  box-sizing: border-box;
  padding-bottom: 2.5rem;
  .upload-img-content {
    text-align: center;
    padding: 0.3rem 0.32rem 0;
    .content-title {
      font-size: 0.4rem;
      color: #1f2933;
      margin: 0.24rem 0;
    }
    .content-subtitle {
      font-size: 0.3rem;
      color: #1f2933;
      text-align: left;
      margin-bottom: 0.1rem;
    }
    .content-p {
      text-align: left;
      font-size: 0.28rem;
      color: #949494;
      margin-bottom: 0.2rem;
      line-height: 1.1;
    }
  }
  .upload-input-wrapper {
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    box-sizing: border-box;
    background: #f5f5f7;
    .declare {
      padding: 0.3rem 0.32rem 0;
      font-weight: bold;
      font-size: 0.28rem;
      color: #949494;
      .rule {
        color: #ff7226;
      }
      i {
        display: inline-block;
        vertical-align: middle;
        width: 0.28rem;
        height: 0.28rem;
        background-size: 0.28rem;
        background-image: url(../../images/icon-unchecked@3x.png);
      }
      .active {
        background-image: url(../../images/icon-checked@3x.png);
        &.declare-br-checked {
          background-image: url(../../images/icon_checked_br@3x.png);
        }
      }
    }
    .multi-upload-input {
      position: relative;
      margin: 0.4rem auto;
    }
  }
}
</style>
